import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { officeDetailPath } from './officeRoute';
import { IOfficeContractResponse } from './types';

export async function getOfficeDetail(officeId: string): Promise<IOfficeContractResponse> {
  const headers = await getAuthHeaders();
  const response = await tempMeeApi.get<IOfficeContractResponse>(officeDetailPath(officeId), {
    headers,
  });
  return response.data;
}
